import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon58: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 20" width={width} height={height} {...props}>
      <Path
        d="M2.929 2.92575C6.828 -0.97525 13.172 -0.97525 17.071 2.92575C18.96 4.81475 20 7.32775 20 9.99975C20 12.6718 18.96 15.1848 17.071 17.0748C15.122 19.0248 12.561 19.9998 10 19.9998C7.439 19.9998 4.878 19.0248 2.929 17.0748C1.04 15.1848 0 12.6718 0 9.99975C0 7.32775 1.04 4.81475 2.929 2.92575ZM10 0.999755C7.695 0.999755 5.391 1.87675 3.636 3.63275C1.936 5.33375 1 7.59375 1 9.99975C1 12.4048 1.936 14.6648 3.636 16.3658C7.145 19.8778 12.855 19.8778 16.364 16.3658C18.064 14.6648 19 12.4048 19 9.99975C19 7.59375 18.064 5.33375 16.364 3.63275C14.609 1.87675 12.305 0.999755 10 0.999755ZM13.5 13.9958C13.776 13.9958 14 14.2188 14 14.4958C14 14.7718 13.776 14.9958 13.5 14.9958H6.5C6.224 14.9958 6 14.7718 6 14.4958C6 14.2188 6.224 13.9958 6.5 13.9958H13.5ZM7 5.99576C7.551 5.99576 8 6.44376 8 6.99576C8 7.54776 7.551 7.99576 7 7.99576C6.449 7.99576 6 7.54776 6 6.99576C6 6.44376 6.449 5.99576 7 5.99576ZM13 5.99576C13.551 5.99576 14 6.44376 14 6.99576C14 7.54776 13.551 7.99576 13 7.99576C12.449 7.99576 12 7.54776 12 6.99576C12 6.44376 12.449 5.99576 13 5.99576Z"
        fill="#404040"
      />
    </Icon>
  )
}
